import React from "react";

import { can } from "@src/security/permissions";
import { OperatorAccountRequestDetails } from "./OperatorAccountRequestDetails";

export const displayOperatorAccountRequest = (gui, id) => ({
  uuid: `operator-account-request-${id}`,
  view: () => (
    <OperatorAccountRequestDetails
      gui={gui}
      id={id}
      canManage={can(gui, "MANAGE_OPERATOR_USER")}
    />
  )
});

export default displayOperatorAccountRequest;
